import attachDeviceSelectionContext from '../examExperience/prePostExam/contexts/deviceSelection';
import attachSelectContext from '../utils/selectContext';
import attachLanguageSelectContext from '../utils/languageSelectContext';

export {
  initGa,
  renderFindADoctor,
} from '../reactApps/findADoctor';

export function attachContext () {
  attachDeviceSelectionContext();
  attachSelectContext();
  attachLanguageSelectContext();
}
